import Reactjs from "../Assets/Reactjs.png";
import nextjs from "../Assets/nextjs.png";
import UIUX from "../Assets/UIUX.png";
import wordpress from "../Assets/wordpress.png";
import python from "../Assets/python.png";
import git from "../Assets/git.png";
import NodeJS from "../Assets/NodeJS.jpg";
import ReactNative from "../Assets/ReactNative.png";
import docker from "../Assets/docker.png";

export const skillsData = [
  {
    title: "MERN Stack",
    logo: NodeJS,
    description: "Building efficient backend and full-stack architectures.",
  },
  {
    title: "ReactJS",
    logo: Reactjs,
    description: "Building responsive web apps with components and hooks.",
  },
  {
    title: "NextJS",
    logo: nextjs,
    description: "Fast, SEO-friendly apps with SSR and dynamic routing.",
  },
  {
    title: "Python (Django)",
    logo: python,
    description: "RESTful APIs and optimized backend integrations.",
  },
  {
    title: "UI/UX Design",
    logo: UIUX,
    description: "Crafting modern, user-centric experiences in Figma.",
  },
  {
    title: "React Native",
    logo: ReactNative,
    description: "Cross-platform mobile apps with native capabilities.",
  },
  {
    title: "WordPress",
    logo: wordpress,
    description: "Customizing themes, plugins, and site performance.",
  },
  {
    title: "Docker",
    logo: docker,
    description: "Containerizing applications for seamless deployment.",
  },
  {
    title: "Git",
    logo: git,
    description: "Version control, branching, and team collaboration.",
  },
];